// In the navbar.js file, modify the href links like this:
import React, { useState, useEffect, useContext } from 'react';
import { Link, useHistory, useLocation } from "react-router-dom";
import { SiWhatsapp } from "react-icons/si";
import { AuthContext } from '../auth/authToken.js';
import axios from 'axios';
import Sidebar from './sidebar.js'; // Make sure to import Sidebar
import Logo from '../assets/images/LOGO_BBYSHIN_2.webp';

export default function Navbar() {
    const { isLoggedIn, logout } = useContext(AuthContext);
    const navigate = useHistory();
    const location = useLocation();
    const api = "https://apibbytowing.vercel.app";
    const [sidebarOpen, setSidebarOpen] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (location.hash) {
            setTimeout(() => {
                const element = document.querySelector(location.hash);
                if (element) element.scrollIntoView();
            }, 0);
        }
    }, [location.pathname, location.hash]);

    const handleSectionClick = (e, sectionId) => {
        e.preventDefault();
        if (location.pathname !== '/') {
            navigate.push('/');
            setTimeout(() => {
                const element = document.querySelector(sectionId);
                if (element) element.scrollIntoView();
            }, 100);
        } else {
            const element = document.querySelector(sectionId);
            if (element) element.scrollIntoView();
        }
    };
    

    const handleLogout = async () => {
        try {
            await axios.post(`${api}/api/logout`, {}, { withCredentials: true });
            localStorage.removeItem('accessToken');
            logout();
            navigate.push('/login');
        } catch (error) {
            console.error('Failed to logout:', error);
        }
    };

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <>
            <nav className='bg-[#FCFC00] fixed w-full h-14 flex flex-row-reverse md:flex-row items-center justify-end md:justify-between z-[100] shadow-md gap-4 md:gap-0'>
                <div className='flex flex-row items-center gap-2 md:gap-0'>
                    <Link to="/">
                        <img src={Logo} alt="Company Logo" className='w-24 md:w-40 h-auto pointer' />
                    </Link>
                    <h3 className='font-extrabold text-sm md:text-md lg:text-lg w-[130px] md:w-full'>EMERGENCY ROAD ASSISTANCE</h3>
                </div>
                <div className='hidden md:block'>
                    <ul className='flex flex-row gap-10 text-md items-center'>
                        <li>
                            <Link to="/">Home</Link>
                        </li>
                        <li>
                            <a href="#about" onClick={(e) => handleSectionClick(e, '#about')}>About</a>
                        </li>
                        <li>
                            <a href="#service" onClick={(e) => handleSectionClick(e, '#service')}>Service</a>
                        </li>
                        <li>
                            <Link to="/gallery">Gallery</Link>
                        </li>
                        <li>
                            <a href="#location" onClick={(e) => handleSectionClick(e, '#location')}>Location</a>
                        </li>

                        {isLoggedIn ? (
                            <li>
                                <button onClick={handleLogout} className='bg-black text-white rounded-full py-2 px-4'>
                                    Logout
                                </button>
                            </li>
                        ) : null}
                    </ul>
                </div>
                <div className='bg-[#FCFC00] z-[200] p-2 rounded-full mt-8 md:mr-10 hidden md:block'>
                    <a href="//wa.me/+6282288349889" target='_blank' rel="noopener noreferrer">
                        <button className='bg-black text-white px-3 py-6 lg:py-3 md:px-6 lg:px-10 xl:px-12 rounded-full flex items-center gap-2'>
                            <SiWhatsapp className='w-5 h-5 fill-yellow-200' />
                            <span className='text-sm xl:text-lg hidden lg:block text-yellow-200'>Pesan Sekarang</span>
                        </button>
                    </a>
                </div>
                <div className='block md:hidden ml-4'>
                    <label className="burger" htmlFor="burger">
                        <input type="checkbox" id="burger" onClick={toggleSidebar} />
                        <span></span>
                        <span></span>
                        <span></span>
                    </label>
                </div>
            </nav>
            <Sidebar handleLogout={handleLogout} isLoggedIn={isLoggedIn} sidebarOpen={sidebarOpen} />
        </>
    );
}
// In the navbar.js file, modify the href links like this:

// Then update the links in the return statement:
